$(window).on("load",function(){
	$("body").removeClass("preload");
});
$(function(){

	var body = $('body');

	//SVGスプライト
	$.ajax({
		type: 'get',
		url: '/wp/wp-content/themes/saisho/assets/svg/icons.svg'//ここにパスを入れる（環境に合わせて変更）
	}).done(function(data) {
		var svg = $(data).find('svg');
		body.prepend(svg);
	});

	//ページ内スクロール
	$.smooziee();

	//スクロールしたらクラスを付与
	$(window).scroll(function () {
		if ($(this).scrollTop() > 160) {
			body.addClass("scroll");
		} else {
			body.removeClass("scroll");
		}
	});

	// スクロールアニメーション
	$('.animate').scrolla({
		mobile: true, // モバイルの有効・無効
		once: true, // 発火は１度だけか、視界に入るたびに発火させるか
		animateCssVersion: 4 // used animate.css version (3 or 4)
	});

	//開閉用ボタンをクリックでクラスの切替え
	$('.header_menu_btn').on('click', function () {
		body.toggleClass('open');
		// bodyにopenがあれば
		// if($(body).hasClass('open')){
		// 	$('.header_sp_btn_text').html('閉じる');
		// } else {
		// 	$('.header_sp_btn_text').html('メニュー');
		// }
		return false;
	});

	//メニュー名以外の部分をクリックで閉じる
	// $('body').on('click', function () {
	// 	body.removeClass('open');
	// 	$('.header_sp_btn_text').html('メニュー');
	// });

	//ページトップボタンフッター前で止める
	// $(document).ready(function () {
	// 	$(window).on("scroll", function () {
	// 		scrollHeight = $(document).height();
	// 		scrollPosition = $(window).height() + $(window).scrollTop();
	// 		footHeight = $(".footer").innerHeight();
	// 		if (scrollHeight - scrollPosition <= footHeight) {
	// 			$(".recruit_btn").addClass("on");
	// 		} else {
	// 			$(".recruit_btn").removeClass("on");
	// 		}
	// 	});
	// });

	//アコーディオン
	// $(".toggle_btn").on("click", function() {
	// 	if($(this).hasClass('open')){
	// 		$(this).removeClass("open");
	// 		$(this).prev().find(".toggle_content").removeClass("open");
	// 		$(this).find(".toggle_btn_prev_text").html("続きを読む");
	// 		var position = $(this).prev().offset().top;
	// 		$("html,body").animate({
	// 			scrollTop : position - 400 //スクロール位置調整
	// 		});
	// 	} else {
	// 		$(this).toggleClass("open");
	// 		$(this).prev().find(".toggle_content").toggleClass("open");
	// 		$(this).find(".toggle_btn_prev_text").html("閉じる");
	// 	}
	// });

	//動画ポップアップ
	$('.popup-youtube').magnificPopup({
		type: 'iframe',
		iframe: {
			markup: '<div class="mfp-iframe-scaler">' +
				'<div class="mfp-close"></div>' +
				'<iframe class="mfp-iframe" allow="autoplay"></iframe>' +
				'</div>',
			patterns: {
				youtube: {
					index: 'youtube.com/',
					id: 'v=',
					src: 'https://www.youtube.com/embed/%id%?autoplay=1'
				}
			}
		}
	});

	// if ( ($('.service').length) || ($('.company').length) ) {
		
	// }

	if($('.service').length) {
		//冒頭スライダー
		var swiper = new Swiper(".intro_swiper", {
			speed: 800,
			loop:true,
			effect: "fade",
			autoplay: {
				delay: 4000,
			},
		});
		//カーライフサポート
		const carlife_swiper = new Swiper(".carlife_swiper", {
			speed: 500,
			loop:true,
			effect: "fade",
			autoplay: {
				delay: 4000,
			},
		});
		carlife_swiper.autoplay.stop(); //画面に現れるまでswiperを停止
		$(window).on('scroll', function () {
			let position = $('.carlife_swiper').offset().top - $(window).innerHeight() + 100,
				scrollTop = $(window).scrollTop(); 
			if(scrollTop > position) {
				carlife_swiper.autoplay.start(); //画面に現れたらswiperを開始
			}else{
				carlife_swiper.autoplay.stop(); // 画面外にスクロールしたらswiperを停止
			}
		});

		//レンタカー
		const rentacar_swiper = new Swiper(".rentacar_swiper", {
			speed: 500,
			loop:true,
			effect: "fade",
			autoplay: {
				delay: 4000,
			},
		});
		rentacar_swiper.autoplay.stop(); //画面に現れるまでswiperを停止
		$(window).on('scroll', function () {
			let position = $('.rentacar_swiper').offset().top - $(window).innerHeight() + 100,
				scrollTop = $(window).scrollTop(); 
			if(scrollTop > position) {
				rentacar_swiper.autoplay.start(); //画面に現れたらswiperを開始
			}else{
				rentacar_swiper.autoplay.stop(); // 画面外にスクロールしたらswiperを停止
			}
		});

		//車検・リペア
		const repair_swiper = new Swiper(".repair_swiper", {
			speed: 500,
			loop:true,
			effect: "fade",
			autoplay: {
				delay: 4000,
			},
		});
		repair_swiper.autoplay.stop(); //画面に現れるまでswiperを停止
		$(window).on('scroll', function () {
			let position = $('.repair_swiper').offset().top - $(window).innerHeight() + 100,
				scrollTop = $(window).scrollTop(); 
			if(scrollTop > position) {
				repair_swiper.autoplay.start(); //画面に現れたらswiperを開始
			}else{
				repair_swiper.autoplay.stop(); // 画面外にスクロールしたらswiperを停止
			}
		});

		//自動車 買取・販売
		const buying_swiper = new Swiper(".buying_swiper", {
			speed: 500,
			loop:true,
			effect: "fade",
			autoplay: {
				delay: 4000,
			},
		});
		buying_swiper.autoplay.stop(); //画面に現れるまでswiperを停止
		$(window).on('scroll', function () {
			let position = $('.buying_swiper').offset().top - $(window).innerHeight() + 100,
				scrollTop = $(window).scrollTop(); 
			if(scrollTop > position) {
				buying_swiper.autoplay.start(); //画面に現れたらswiperを開始
			}else{
				buying_swiper.autoplay.stop(); // 画面外にスクロールしたらswiperを停止
			}
		});

		//石油＋LPガス
		const oil_swiper = new Swiper(".oil_swiper", {
			speed: 500,
			loop:true,
			effect: "fade",
			autoplay: {
				delay: 4000,
			},
		});
		oil_swiper.autoplay.stop(); //画面に現れるまでswiperを停止
		$(window).on('scroll', function () {
			let position = $('.oil_swiper').offset().top - $(window).innerHeight() + 100,
				scrollTop = $(window).scrollTop(); 
			if(scrollTop > position) {
				oil_swiper.autoplay.start(); //画面に現れたらswiperを開始
			}else{
				oil_swiper.autoplay.stop(); // 画面外にスクロールしたらswiperを停止
			}
		});

		//住宅リフォーム
		// const reform_swiper = new Swiper(".reform_swiper", {
		// 	speed: 500,
		// 	loop:true,
		// 	effect: "fade",
		// 	autoplay: {
		// 		delay: 4000,
		// 	},
		// });
		// reform_swiper.autoplay.stop(); //画面に現れるまでswiperを停止
		// $(window).on('scroll', function () {
		// 	let position = $('.reform_swiper').offset().top - $(window).innerHeight() + 100,
		// 		scrollTop = $(window).scrollTop();
		// 	if(scrollTop > position) {
		// 		reform_swiper.autoplay.start(); //画面に現れたらswiperを開始
		// 	}else{
		// 		reform_swiper.autoplay.stop(); // 画面外にスクロールしたらswiperを停止
		// 	}
		// });

		// 住宅リフォーム
	  	// 要素が存在するか確認
	  	if ($('.reform_swiper').length > 0) {
	    	const reform_swiper = new Swiper(".reform_swiper", {
	      		speed: 500,
	      		loop: true,
	      		effect: "fade",
	      		autoplay: {
	        		delay: 4000,
	      		},
	    	});
	    	reform_swiper.autoplay.stop(); //画面に現れるまでswiperを停止
	    	$(window).on('scroll', function () {
	      		// 要素が存在するか再確認
	      		if ($('.reform_swiper').length > 0 && $('.reform_swiper').offset()) {
	        		let position = $('.reform_swiper').offset().top - $(window).innerHeight() + 100,
	            	scrollTop = $(window).scrollTop();
	        		if (scrollTop > position) {
	          			reform_swiper.autoplay.start(); //画面に現れたらswiperを開始
	        		} else {
	          			reform_swiper.autoplay.stop(); // 画面外にスクロールしたらswiperを停止
	        		}
	      		}
	    	});
	  	}

		//游心の湯
		const yushin_swiper = new Swiper(".yushin_swiper", {
			speed: 500,
			loop:true,
			effect: "fade",
			autoplay: {
				delay: 4000,
			},
		});
		yushin_swiper.autoplay.stop(); //画面に現れるまでswiperを停止
		$(window).on('scroll', function () {
			let position = $('.yushin_swiper').offset().top - $(window).innerHeight() + 100,
				scrollTop = $(window).scrollTop(); 
			if(scrollTop > position) {
				yushin_swiper.autoplay.start(); //画面に現れたらswiperを開始
			}else{
				yushin_swiper.autoplay.stop(); // 画面外にスクロールしたらswiperを停止
			}
		});

		//KOMOREBI
		const komorebi_swiper = new Swiper(".komorebi_swiper", {
			speed: 500,
			loop:true,
			effect: "fade",
			autoplay: {
				delay: 4000,
			},
		});
		komorebi_swiper.autoplay.stop(); //画面に現れるまでswiperを停止
		$(window).on('scroll', function () {
			let position = $('.komorebi_swiper').offset().top - $(window).innerHeight() + 100,
				scrollTop = $(window).scrollTop(); 
			if(scrollTop > position) {
				komorebi_swiper.autoplay.start(); //画面に現れたらswiperを開始
			}else{
				komorebi_swiper.autoplay.stop(); // 画面外にスクロールしたらswiperを停止
			}
		});

		//おとぎの杜
		const otogi_swiper = new Swiper(".otogi_swiper", {
			speed: 500,
			loop:true,
			effect: "fade",
			autoplay: {
				delay: 4000,
			},
		});
		otogi_swiper.autoplay.stop(); //画面に現れるまでswiperを停止
		$(window).on('scroll', function () {
			let position = $('.otogi_swiper').offset().top - $(window).innerHeight() + 100,
				scrollTop = $(window).scrollTop(); 
			if(scrollTop > position) {
				otogi_swiper.autoplay.start(); //画面に現れたらswiperを開始
			}else{
				otogi_swiper.autoplay.stop(); // 画面外にスクロールしたらswiperを停止
			}
		});
	}

	if($('.company').length) {
		var swiper = new Swiper(".history_swiper", {
			// initialSlide: 0,
			slidesPerView:"auto",
			navigation: {
				nextEl: ".history_swiper_box .swiper-button-next",
				prevEl: ".history_swiper_box .swiper-button-prev",
			},
			breakpoints: {
				320: {
					// slidesPerView: 1.8,
					spaceBetween: 15,
				},
				// 768px以上の場合
				767: {
					
					spaceBetween: 30,
				},
			},
		});
	}

	//Youtube パララックス 左
	const elem_left = document.querySelector(".parallax_left");
	if (elem_left !== null) {
		let target = document.getElementsByClassName("parallax_left");
			let parallaxConfig = {
				delay: 1, // スクロール止めてから動く秒数
				orientation: "left", // 動く方向
				scale: 2.3, // 動く大きさ
				overflow: true,
				maxTransition: 50,
			};
		const parallax_instance = new simpleParallax(target, parallaxConfig);
	}

	//Youtube パララックス 右
	const elem_right = document.querySelector(".parallax_right");
	if (elem_right !== null) {
		let target = document.getElementsByClassName("parallax_right");
			let parallaxConfig = {
				delay: 1, // スクロール止めてから動く秒数
				orientation: "right", // 動く方向
				scale: 1.9, // 動く大きさ
				overflow: true,
				maxTransition: 50,
			};
		const parallax_instance = new simpleParallax(target, parallaxConfig);
	}

});